export default __webpack_public_path__ + "static/GT-America-Compressed-Medium-5957f19c1eab6f9543f828582020a789.woff2";